<div class="nacha-process-step">
  <div class="process-content">
    @if (isProcessing) {
      <mat-progress-spinner mode="indeterminate" diameter="64" color="primary"></mat-progress-spinner>
      <h3>Processing ACH Payments...</h3>
      <p>Submitting {{ totalCount }} ACH payment{{ totalCount !== 1 ? 's' : '' }}. Please wait.</p>
      <mat-progress-bar mode="indeterminate" color="primary"></mat-progress-bar>
    } @else {
      <mat-icon class="done-icon">check_circle</mat-icon>
      <h3>Processing Complete</h3>
      <p>All payments have been submitted.</p>
    }
  </div>
</div>
